import { render, staticRenderFns } from "./voucherBaseEdit.vue?vue&type=template&id=0b7b8380"
import script from "./voucherBaseEdit.vue?vue&type=script&lang=js"
export * from "./voucherBaseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports